<template>
  <v-container>
    <div class="mt-12">
      <h1>Continuum User Agreement</h1>
      <p>
        Before you can use Continuum, you must take the appropriate training and agree to the terms and conditions.
      </p>
      <p>
        <v-card outlined elevation="0">
          <v-card-text>
            <h2>Welcome</h2>
            <p class="mt-3">
              OCHIN utilizes the Continuum release management application to communicate changes made to OCHIN Epic and
              associated member applications. Within Continuum, release notes serve as the technical documentation for
              communicating changes to the production environment. These release notes offer member organizations
              insight into the evolving products which are organized based on their associated pack.
            </p>
            <p>
              Continuum categorizes release notes by pack type, and upon logging in, members are presented with their
              active packs. Utilizing an active pack's Pack Status, members can ascertain any actions required to ensure
              successful implementation. Continuum also allows members to assign release notes to individuals within
              their organization responsible for user acceptance testing. Assigned release notes are easily trackable to
              ensure the timely completion of required reviews and testing for each pack.
            </p>
          </v-card-text>
        </v-card>
      </p>
      <p>
        <v-card outlined elevation="0">
          <v-card-text>
            <h2>Training</h2>
            <p class="mt-3">
              To ensure each Continuum end-user understands the best practices for the use of the system they should
              complete one of the following:
            </p>
            <ul>
              <li>
                Recorded Training - take the
                <a href="https://ella.ochin.org/ip/mod/data/view.php?d=1&rid=3099">Continuum: Member Training</a>
                available in Ella
              </li>
              <li>
                Live Onboarding - attend a
                <a href="https://ochin421.sharepoint.com/sites/RCM/SitePages/Calendar.aspx">monthly onboarding</a> to
                the OCHIN Epic Release Cycle
              </li>
              <li>
                Training Guide - reviewed the
                <a href="https://ella.ochin.org/ip/mod/data/view.php?d=1&rid=3046">Continuum Member Training Guide</a>
              </li>
            </ul>

            <p class="mt-6">
              By checking the box below you are indicating you have completed the
              <a href="https://ella.ochin.org/ip/mod/data/view.php?d=1&rid=3099">Continuum: Member Training</a> or have
              attended the
              <a href="https://ochin421.sharepoint.com/sites/RCM/SitePages/Calendar.aspx"
                >OCHIN Epic Release Cycle New Member Onboarding</a
              >
              and are aware of the
              <a href="https://ella.ochin.org/ip/mod/data/view.php?d=1&rid=3046">Continuum Member Training Guide</a>.
            </p>

            <v-checkbox v-model="agreeToTraining" label=" I have completed and reviewed the above items" :value="true">
            </v-checkbox>
          </v-card-text>
        </v-card>
      </p>
      <div>
        <div class="mt-6">
          <v-btn color="primary" elevation="0" @click="submit" :disabled="!agreeToTraining">Submit</v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { fetchApi } from "@/api/fetchApi";

export default {
  name: "trainingAgreementApp",
  data() {
    return {
      agreeToTraining: false,
    };
  },
  created() {
    if (this.$store.state.session.trainingAgreementAccepted) {
      this.$router.push("/");
    }
  },
  methods: {
    async submit() {
      if (!this.agreeToTraining) {
        alert("You must agree to the training and terms and conditions before you can use Continuum.");
        return;
      }

      try {
        await fetchApi({
          method: "POST",
          url: "/api/trainingAgreement",
          data: {
            acceptedAgreement: this.agreeToTraining,
          },
        });

        location.href = "/";
      } catch (e) {
        alert("An error occurred while submitting the training agreement. Please try again.");
      }
    },
  },
};
</script>
